import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const BarGraph14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path d='M10.75 1V10H12.25V1H10.75Z' fill='currentColor' />
    <path d='M1.75 10V7H3.25V10H1.75Z' fill='currentColor' />
    <path d='M0 11.25H14V12.75H0V11.25Z' fill='currentColor' />
    <path d='M6.25 3V10H4.75V3H6.25Z' fill='currentColor' />
    <path d='M9.25 10V5H7.75V10H9.25Z' fill='currentColor' />
  </Svg>
);

BarGraph14.displayName = 'BarGraph14';
export default BarGraph14;
